import { Button, Dialog } from "../../../design-v2";

function formatTime(value) {
  if (!value || Number.isNaN(new Date(value).getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}

export default function RecoveryDialog({
  open,
  mode,
  otherDevice,
  offline,
  notice = null,
  busy,
  // An empty ACTIVE workout cannot go to Review: the action stays, locked.
  finishLocked = false,
  startedAt,
  lastActivityAt,
  onAction,
}) {
  const finished = mode === "finished";
  const started = formatTime(startedAt);
  const lastActivity = formatTime(lastActivityAt);
  const activeDescription = started && lastActivity
    ? `Started ${started} · last activity ${lastActivity}.`
    : "This workout has been idle for at least an hour.";
  return (
    <Dialog
      open={open}
      dismissible={false}
      showCloseButton={false}
      title={finished ? "Finish this workout" : "Workout in progress"}
      description={otherDevice
        ? "Changes not yet synced from the other device won't be included."
        : finished
          ? "Review, save, or discard this finished workout."
          : activeDescription}
    >
      <div className="lz-workout-dialog-actions">
        {offline ? <p className="lz-workout-offline-reason">Needs a connection</p> : null}
        {notice ? <p className="lz-workout-offline-reason" role="status">{notice}</p> : null}
        <Button disabled={busy} onClick={() => onAction(finished ? "continue" : "resume")}>
          {otherDevice ? "Resume here" : finished ? "Continue Editing" : "Resume Workout"}
        </Button>
        {/* A workout owned by another device is only resumed here: its content
            is not known before the takeover, so Finish is decided afterwards,
            by the editor's own Finish button. */}
        {!finished && !otherDevice ? (
          <Button variant="secondary" disabled={busy || finishLocked} onClick={() => onAction("finish")}>
            Finish &amp; Review
          </Button>
        ) : null}
        {finished && !otherDevice ? (
          <Button variant="secondary" disabled={busy} onClick={() => onAction("save")}>Save Workout</Button>
        ) : null}
        <Button variant="danger" disabled={busy} onClick={() => onAction("discard")}>Discard Workout</Button>
      </div>
    </Dialog>
  );
}

export { formatTime };
